export var MPAResourceSelectionMode;
(function (MPAResourceSelectionMode) {
    MPAResourceSelectionMode["MPA_RESOURCE_SELECTION_MODE_ALL"] = "ALL";
    MPAResourceSelectionMode["MPA_RESOURCE_SELECTION_MODE_NONE"] = "NONE";
})(MPAResourceSelectionMode || (MPAResourceSelectionMode = {}));
